/**
 * Deteksi embed/standalone mode: halaman dibuka dari WebView aplikasi mobile
 * OneLNK (inbox approval) dengan `?embed=true` atau `?mode=standalone`.
 *
 * Query hanya ada di URL pertama (kartu inbox), jadi penandanya disimpan di
 * sessionStorage supaya bertahan melewati login ulang dan navigasi di dalam
 * SPA. Kembaran `helpers/embedMode.js` di fe-web-hris-rebuild, fe-asset-opname
 * dan fe-web-dcis-new: satu kontrak untuk semua aplikasi
 * (mobile-oneworkspace docs/pedoman-deep-link-approval.md §3.2).
 */

export const EMBED_FLAG_KEY = 'embedMode';

/**
 * @param {string} [search] query halaman, bawaannya `window.location.search`
 * @param {{getItem: Function, setItem: Function}} [storage] bawaannya sessionStorage
 * @returns {boolean}
 */
export const detectEmbedMode = (
	search = window.location.search,
	storage = window.sessionStorage,
) => {
	try {
		const params = new URLSearchParams(search);
		if (params.get('mode') === 'standalone' || params.get('embed') === 'true') {
			storage.setItem(EMBED_FLAG_KEY, 'true');
		}
		return storage.getItem(EMBED_FLAG_KEY) === 'true';
	} catch (e) {
		// Penyimpanan ditolak (mode privat): perlakukan sebagai peramban biasa.
		return false;
	}
};

export default detectEmbedMode;
